import Net from '@/services/net'

export function getTargetsReport(catalogCode: number) {
  return Net.t1.get<Record<string, object>[]>(`catalogs/${catalogCode}/targets/reports`)
}
